<template>
  <div class="align-middle d-print-none align-items-baseline">
    <router-link
      class="wallet-plain-link"
      :to="{name:'UserWallets',params:{user:$store.getters['User/getProfile'].id}}"
    >
      مدیریت کیف پول
    </router-link>
  </div>
</template>

<script>
export default {
  name: "widget",
}
</script>

<style scoped>
.wallet-plain-link {
  display: block;
  color: inherit !important;
  text-decoration: none !important;
  font-size: 12px;
  font-weight: 700;
}
</style>
